import React from 'react';
import { useSellviaActivity } from '../../../context/SellviaActivityContext';

// Sits right below MainNav, same slot pattern as SellviaCleanupBanner —
// shows live progress for the two activities that don't already have a
// banner of their own: the Approved tab's "Process Order" (single or bulk)
// and every page's "Sync Live"/"Sync All" button. Visible on every admin
// page since it lives in AdminLayout, not inside any one page.
const SellviaActivityBanner = () => {
    const ctx = useSellviaActivity();
    const activity = ctx?.activity;
    if (!activity) return null;

    const isRunning = activity.status === 'running';
    const isError = activity.status === 'error';
    const pct = activity.total > 0 ? Math.round((activity.current / activity.total) * 100) : 0;
    const typeLabel = activity.type === 'sync' ? 'Sync Live' : 'Process Order';

    return (
        <div style={{
            position: 'sticky', top: 'var(--MainNav-height, 56px)', zIndex: 997,
            background: isError ? '#7f1d1d' : 'linear-gradient(90deg, #6f5212 0%, #8c6a1c 55%, #b8892c 100%)', color: '#fff', padding: '10px 24px',
            display: 'flex', alignItems: 'center', gap: 16, boxShadow: '0 4px 16px rgba(111,82,18,0.35)',
            flexWrap: 'wrap',
        }}>
            <style>{`@keyframes ms-activity-spin { to { transform: rotate(360deg); } }`}</style>
            {isRunning ? (
                <span style={{ width: 16, height: 16, border: '2px solid #f3d58a', borderTopColor: '#fff', borderRadius: '50%', display: 'inline-block', animation: 'ms-activity-spin 0.7s linear infinite', flexShrink: 0 }} />
            ) : (
                <span style={{ fontSize: 15, flexShrink: 0 }}>{isError ? '✕' : '✓'}</span>
            )}
            <span style={{ fontWeight: 700, fontSize: 13, whiteSpace: 'nowrap' }}>
                {typeLabel}{activity.label ? `: ${activity.label}` : ''}
            </span>
            {activity.message && (
                <span style={{ fontSize: 12, color: '#f6e9cc', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: 360 }}>
                    {activity.message}
                </span>
            )}
            {activity.total > 0 && (
                <div style={{ flex: 1, background: 'rgba(255,255,255,0.22)', borderRadius: 4, height: 6, minWidth: 80 }}>
                    <div style={{ width: `${pct}%`, height: '100%', background: isError ? '#ef4444' : '#f3d58a', borderRadius: 4, transition: 'width 0.2s' }} />
                </div>
            )}
            {(activity.successCount > 0 || activity.failCount > 0) && (
                <span style={{ fontSize: 12, color: '#f3d58a', whiteSpace: 'nowrap' }}>
                    ✅ {activity.successCount}{activity.failCount > 0 ? ` ❌ ${activity.failCount}` : ''}
                </span>
            )}
        </div>
    );
};

export default SellviaActivityBanner;
